import { Icon, Text } from '@cencosud-cencommerce/paris-uikit';

import useKeyPress from '@/Application/Hooks/useKeyPress/useKeyPress';
import { SendShippingEvents } from '@/modules/shared/utils/gtmEvents';
import type { GtmGroupsData } from '@/modules/shared/utils/gtmEvents/types';
import {
  ShippingEventInteractiveActions,
  ShippingEventInteractiveTags
} from '@/modules/shared/utils/gtmEvents/types';

interface Props {
  onChooseDate: VoidFunction;
  gtmData?: GtmGroupsData;
}

export const SelectAnotherDate = ({ onChooseDate, gtmData }: Props) => {
  const { onKeyDown } = useKeyPress(onChooseDate);
  const handleClick = () => {
    SendShippingEvents.sendEvent({
      event: 'baseEvent',
      extraFields: {
        'event-interactive-tag': ShippingEventInteractiveTags.ChooseAnotherDate,
        'event-interactive-accion':
          ShippingEventInteractiveActions.DispatchIntearctions,
        'event-interactive-grupo_despacho': `${gtmData?.groupNumber ?? ''} - ${gtmData?.totalGroups ?? ''}`
      }
    });
    onChooseDate();
  };
  return (
    <div
      tabIndex={0}
      role={'button'}
      className="co-px-3 co-py-4 co-flex co-gap-2 co-border-t co-border-t-neutral-300 ui-focus-2"
      onKeyDown={onKeyDown}
    >
      <Icon name="il-book-service" />
      <Text
        variant="link2"
        weight={600}
        onClick={handleClick}
        color="primary-500"
      >
        Elegir otra fecha
      </Text>
    </div>
  );
};
